import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ContinentsAgents.css';
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const ContinentsAgents = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [activeAgents, setActiveAgents] = useState([]);

    const [title, setTitle] = useState('');
    const {continentid} = useParams();

    // useEffect(() => {
    //     Promise.all([
    //         // getambassadorlist()
            
    //     ])
    //     .then(() => {
    //         setIsLoading(false);
    //     })
        
    // },[]);

    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Matthew Judd',
                city:'Toronto',
                state: 'Alabama',
                country:'US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Baseball',
            },
            {   
                id: "2", 
                name: 'Ambia Mari Abolucion',
                city:'Chelsea',
                state: 'Alabama',
                country:'US',
                url:'',
                // continent:{value:'7', label:'North America'},
                sport: 'Basketball',
            },
            {   
                id: "3", 
                name: 'Ashok Anjara',
                city:'Phoenix',
                state: 'Arizona',
                country:'US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football',
            },
            {   
                id: "4", 
                name: 'Ashok Anjara',
                city:'',
                state: 'California',
                country:'US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football (American)',
            }
        ];
        //setActiveAgents(staticData);
    },[]);

        //pagination
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(50);
    
            const startIndex =
                (currentPage - 1) * itemsPerPage;
            const endIndex =
                startIndex + itemsPerPage;
            const currentItems =
                activeAgents.slice(startIndex, endIndex);
    
        function goToNextPage() {
            setCurrentPage(prevPage => prevPage + 1);
        }
    
        function goToPrevPage() {
            setCurrentPage(prevPage => prevPage - 1);
        }
    
        function goToSpecificPage(pageNumber) {
            setCurrentPage(pageNumber);
        }
        function renderPaginationControls() {
            const totalPages = Math.ceil(activeAgents.length / itemsPerPage);

            const goToFirstPage = () => setCurrentPage(1);
            const goToLastPage = () => setCurrentPage(totalPages);

            const maxButtons = 10;
            let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
            let endPage = startPage + maxButtons - 1;

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            const pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            return (
                <div>
                    {activeAgents.length > itemsPerPage && (
                        <div style={{ textAlign: "center" }} className="continent-agent-pagination">

                            {/* First + Prev */}
                            {currentPage !== 1 && (
                                <>
                                    <button onClick={goToFirstPage}>« First</button>
                                    <button onClick={goToPrevPage}>‹ Previous</button>
                                </>
                            )}
                            {pageNumbers.map((num) => (
                                <button
                                    key={num}
                                    onClick={() => goToSpecificPage(num)}
                                    style={{
                                        fontWeight: num === currentPage ? "bold" : "normal",
                                        color: num === currentPage ? "#111" : "#2c99d2",
                                    }}
                                >
                                    {num}
                                </button>
                            ))}

                            {/* Next + Last */}
                            {currentPage !== totalPages && (
                                <>
                                    <button onClick={goToNextPage}>Next ›</button>
                                    <button onClick={goToLastPage}>Last »</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }
        const lastPageIndex = Math.min(activeAgents.length, endIndex);

    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwagency/getagentcontinentlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: currentPage,
            pagesize: itemsPerPage,
            id:continentid
              }),
            });
            const data = await response.json();
            setActiveAgents(data.data.result);
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
        }, [currentPage]); // Re-fetch data when these change

    return (
        <>
        {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="continent-agent-main">
                    <Helmet><title>Continents Agents</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="view-header">
                            <div style={{textAlign: "right"}}><a href="/sports_agents_map" style={{cursor: "pointer"}}>« Back to the World Map</a></div>
                        </div>
                        {activeAgents.length === 0 ? (<p>There are currently no agents available for your selection.</p>) : (
                            <>
                                {activeAgents ? (
                                    <div>{activeAgents.length} agent(s) found.</div>
                                ) : (<></>)} 
                                <div>
                                    <div className="continents_agents_wrapper">    
                                        <ul>   
                                            {currentItems.map((agent, index) => (       
                                                <li>  
                                                    <div key={index}>        
                                                        <div><a href={agent.url} target="_blank">{agent.name}</a></div>  
                                                    </div>  
                                                    {agent?.address && 
                                                        <div>        
                                                            <div>&nbsp;-  {agent.address}</div>  
                                                        </div>
                                                    }
                                                    
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    {renderPaginationControls()}
                                </div>
                            </>
                        )}
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default ContinentsAgents;